module.exports = __webpack_public_path__ + "img/ETCRechargeRecord.cb03d03b.svg";